import React, {FC} from 'react'
import {MDBBtn} from 'mdb-react-ui-kit'

const Toggle: FC = () => (
 <div style={{ position: 'fixed', top: '80%' , bottom: '20%' }}>
   <button
     id='kt_explore_toggle'
     className='btn btn-sm  bg-teal-400 text-white shadow-sm px-5 fw-bolder zindex-2   w-30  end-0 transform-90 fs-6 rounded-top-0'
     title={`Explore ${process.env.REACT_APP_THEME_NAME}`}
     data-bs-toggle='tooltip'
     data-bs-placement='right'
     data-bs-trigger='hover'
   >
     <span id='kt_explore_toggle_label'> پشتیبانی </span>
   </button>
 </div>
)

export {Toggle}
